import type { Edge } from "@xyflow/react"

const INVALID_HANDLE_VALUES = new Set(["", "null", "undefined"])

function isValidHandleValue(value: unknown): value is string {
  return typeof value === "string" && !INVALID_HANDLE_VALUES.has(value)
}

export function normalizeWorkflowEdgeHandles(edge: Edge): Edge {
  const { sourceHandle, targetHandle, ...rest } = edge
  return {
    ...rest,
    // Canvas defaultEdgeOptions, loadGraph, and refetch signatures all treat
    // workflow edges as labeled. Force that here so save baselines and server
    // refetches compare equal after ordinary onConnect/addEdge paths.
    type: "labeled",
    ...(isValidHandleValue(sourceHandle) ? { sourceHandle } : {}),
    ...(isValidHandleValue(targetHandle) ? { targetHandle } : {}),
  }
}

export function normalizeWorkflowEdges(edges: Edge[]): Edge[] {
  return edges.map(normalizeWorkflowEdgeHandles)
}
